module.exports = __webpack_public_path__ + "img/ff03.18717f52.svg";